import React from 'react';
import { Menu, MenuItem, ListItemIcon, Divider, Box, Typography, Avatar } from '@mui/material';
import {
  AccountCircle,
  Settings as SettingsIcon,
  Logout,
} from '@mui/icons-material';

interface UserMenuProps {
  anchorEl: null | HTMLElement;
  userName: string | null;
  onClose: () => void;
  onLogout: () => void;
}

const UserMenu: React.FC<UserMenuProps> = ({ anchorEl, userName, onClose, onLogout }) => {
  const avatarLetter = userName ? userName.charAt(0).toUpperCase() : 'U';
  return (
  <Menu
    anchorEl={anchorEl}
    id="account-menu"
    open={Boolean(anchorEl)}
    onClose={onClose}
    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    PaperProps={{
      elevation: 3,
      sx: { mt: 1.5, minWidth: 220 },
    }}
  >
    <Box
      sx={{
        px: 2,
        py: 2,
        pb: 1.5,
        borderBottom: 1,
        borderColor: 'divider',
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
        <Avatar sx={{ width: 40, height: 40, bgcolor: 'primary.main' }}>{avatarLetter}</Avatar>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="subtitle2" fontWeight={600} noWrap>
            {userName ? `Hi, ${userName}!` : 'Account'}
          </Typography>
        </Box>
      </Box>
    </Box>
    <MenuItem onClick={onClose}>
      <ListItemIcon>
        <AccountCircle fontSize="small" />
      </ListItemIcon>
      Profile
    </MenuItem>
    <MenuItem onClick={onClose}>
      <ListItemIcon>
        <SettingsIcon fontSize="small" />
      </ListItemIcon>
      Settings
    </MenuItem>
    <Divider />
    <MenuItem onClick={onLogout}>
      <ListItemIcon>
        <Logout fontSize="small" />
      </ListItemIcon>
      Logout
    </MenuItem>
  </Menu>
  );
};

export default UserMenu;
